var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2297_6072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.12 0C5.87409 0 0 5.87409 0 13.12C0 19.2728 4.23619 24.4357 9.95073 25.8537V17.1295H7.24539V13.12H9.95073V11.3924C9.95073 6.92684 11.9717 4.85702 16.3559 4.85702C17.1872 4.85702 18.6215 5.02024 19.2082 5.18293V8.81716C18.8986 8.78463 18.3607 8.76836 17.6926 8.76836C15.5414 8.76836 14.7101 9.58337 14.7101 11.702V13.12H18.9957L18.2594 17.1295H14.7101V26.144C21.2066 25.3594 26.2405 19.828 26.2405 13.12C26.24 5.87409 20.3659 0 13.12 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 0C5.87409 0 0 5.87409 0 13.12C0 19.2728 4.23619 24.4357 9.95073 25.8537V17.1295H7.24539V13.12H9.95073V11.3924C9.95073 6.92684 11.9717 4.85702 16.3559 4.85702C17.1872 4.85702 18.6215 5.02024 19.2082 5.18293V8.81716C18.8986 8.78463 18.3607 8.76836 17.6926 8.76836C15.5414 8.76836 14.7101 9.58337 14.7101 11.702V13.12H18.9957L18.2594 17.1295H14.7101V26.144C21.2066 25.3594 26.2405 19.828 26.2405 13.12C26.24 5.87409 20.3659 0 13.12 0Z",
    fill: "url(#paint0_linear_2297_6072)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2297_6072",
    x1: 23.2728,
    y1: -3.07042,
    x2: 2.10934,
    y2: 46.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4383FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0D1F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2297_6072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.24,
    height: 26.24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aa583e99579cef8200930b6ec964bf34.svg";
export { ForwardRef as ReactComponent };